<template>
    <modal size="medium" :no-footer="true" @close="$emit('close')">
        <template slot="header">
            <strong>Download Ledger Report</strong>
        </template>

        <template slot="content">
            <div class="flex ai-c">
                <div v-show="loadingReport" class="flex ai-c mr-2">
                    <img src="../../assets/img/loading-black-32.gif" alt="loading" />
                </div>

                <span>Generating report for <strong>{{ facility.facility_number }}</strong></span>
            </div>

            <div v-if="errorMessage.length">
                <hr class="small" />

                <i class="danger-text material-icons">report</i>
                <span class="ml-1">{{ errorMessage }}</span>
            </div>

            <div v-if="downloadFileName !== null" class="mt-3">
                <a :href="downloadFilePath" target="_blank">Download Report</a>
            </div>
        </template>
    </modal>
</template>

<script>
import http from "@/http"

export default {
    props: {
        facility: {
            required: true,
            type: Object
        },
        software: {
            required: true,
            type: String
        }
    },

    data () {
        return {
            downloadFileName: null,
            errorMessage: "",
            loadingReport: false
        }
    },

    computed: {
        downloadFilePath () {
            if (this.downloadFileName === null) {
                return null
            }

            let url = `${http.defaults.baseURL}/api/exports/download`
            url += `?file_key=${this.downloadFileName}&filename=${this.facility.facility_number}_ledger`

            return url
        }
    },

    mounted () {
        this.generateReport()
    },

    methods: {
        /**
         * Generate the report for the facility.
         */
        async generateReport () {
            this.loadingReport = true

            try {
                let path

                switch (this.software) {
                case "sitelink":
                    path = "/api/exports/sitelink-rent-roll-report"
                    break

                case "storedge":
                    path = "/api/exports/storedge-ledger-report"
                    break

                default:
                    throw new Error("Facility has an invalid software type!")
                }

                const queryParams = {
                    facility_number: this.facility.facility_number
                }

                const {
                    data: {
                        export_file: exportFile
                    }
                } = await http(path, { params: queryParams })

                this.downloadFileName = exportFile.name

                let url = `${http.defaults.baseURL}/api/exports/download`
                url += `?file_key=${this.downloadFileName}&filename=${this.facility.facility_number}_ledger`

                window.open(url, "_blank")
            } catch (ex) {
                if (ex.message) {
                    this.errorMessage = ex.message
                } else {
                    this.errorMessage = ex
                }
            } finally {
                this.loadingReport = false
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list-facilities-page/DownloadLedgerModal.vue